<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
  >
    <v-card dark class="app-dialog">
      <div class="app-dialog__title">
        <center>
          <div class="app-dialog__logo"></div>
        </center>
        <h2 class="mt-5">กงล้อนำโชค</h2>
        <v-btn
          class="app-dialog__close-btn"
          icon
          @click="close"
        >
          <v-icon>
            fas fa-times
          </v-icon>
        </v-btn>
      </div>
      <div class="app-dialog__container">
        <div class="my-5">
          <v-progress-linear
            v-show="disabled"
            indeterminate
            color="red"
          />
          <div
            class="d-flex justify-center pa-5"
          >
              <div>
                <center>
                  <p>
                    จำนวนครั้งที่หมุนได้
                    {{ Number(fortuneWheelData.round || 0) - Number(fortuneWheelData.played || 0) }}
                  </p>
                </center>
                <fortune-wheel
                  :verify="true"
                  type="image"
                  :prizes="prizes"
                  :disabled="disabled"
                  :prize-id="prize"
                  :canvas="{
                    borderWidth: 3,
                    borderColor: '#584b43',
                    btnText: `หมุนได้ ${fortuneWheelData.round} ครั้ง`
                  }"
                  :angle-base="6.080"
                  @rotateStart="spin"
                  @rotateEnd="onSpinStop"
                >
                  <img slot="wheel" src="@/assets/roulette.png" />
                  <img slot="button" height="100%" src="@/assets/indicator.png" />
                </fortune-wheel>
                <center>
                  <v-btn
                    block
                    class="app-btn"
                    v-show="retry"
                    @click="fetchFortuneWheelData"
                  >
                    ดึงข้อมูลใหม่อีกครั้ง
                  </v-btn>
                </center>
              </div>
          </div>
          <center>
            <h2 class="red--text">*** กติกาการเล่น ***</h2>
          </center>
          <ul>
            <li>
              ต้องหมุนก่อนเล่นเท่านั้นหากเข้าเล่นเกมส์ก่อน
              จะถือว่าท่าน<span class="red--text">สละสิทธิ์</span>ในการหมุนกงล้อที่เหลืออยู่
            </li>
            <li>
              หากการดึงข้อมูลเกิดความ
              <span class="red--text">ผิดพลาด</span>
              จะมีปุ่มให้ท่านดึงข้อมูลใหม่อีกครั้ง
            </li>
            <li>ทุกๆยอดฝาก 200 บาทจะได้รับสิทธิ์ในการหมุน 1 ครั้ง</li>
            <li>รางวัลที่ได้รับจากการหมุนจะต้องทำเทิร์นก่อนถึงจะสามารถถอนได้</li>
            <li>
              หากท่านติดเทิร์นจากโปรโมชั่นอื่นแล้วทำการหมุนกงล้อ
              ยอดเทิร์นของกงล้อจะถูกบวกเข้ากับยอดเทิร์นที่ท่านค้างอยู่
            </li>
          </ul>
          <center>
            <span class="red--text">วิธีคิดเทิร์น</span>
            <p>เทิร์น = (200 + ยอดที่ท่านได้โบนัสจากการหมุน) * 2</p>
          </center>
          <!-- <v-row>
            <v-col cols="12">
              <center>
                <v-btn
                  large
                  depressed
                  block
                  color="amber"
                  dark
                  @click="spin"
                >
                  หมุน ( ครั้งละ 50 บาท )
                </v-btn>
              </center>
            </v-col>
          </v-row> -->
        </div>
        <div class="app-dialog__footer">
          <v-btn
            block
            rounded
            color="#7c7c7c"
          >
            ติดต่อฝ่ายบริการ
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  Component, Vue, Prop, Emit,
} from 'vue-property-decorator';
import FortuneWheel from 'vue-fortune-wheel';
import FortuneWheelService from '@/services/FortuneWheelService';
import 'vue-fortune-wheel/lib/vue-fortune-wheel.css';
import Profile from '@/connector/Profile.vue';

const fortuneWheelService = new FortuneWheelService();

@Component({
  components: {
    FortuneWheel,
    Profile,
  },
})
export default class FotuneWheelGame extends Vue {
  @Prop({ type: Boolean, required: true }) open;

  prize = 0;

  disabled = false;

  retry = false;

  fortuneWheelData = {};

  set dialog(value) {
    this.close();
  }

  get dialog() {
    return this.open;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  async spin(rotate) {
    try {
      this.disabled = true;
      const { data } = await fortuneWheelService.spin();
      // eslint-disable-next-line max-len
      this.prize = this.prizes.findIndex((prize) => Number(prize.value) === Number(data.prizeId)) + 1;
      console.log('this.prize', this.prize);
      rotate();
      this.fortuneWheelData = { ...data.fortuneWheelData };
    } catch (e) {
      this.disabled = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }

  async onSpinStop() {
    this.$store.commit('Snackbar/showNotification', { message: `ยินดีด้วยคุณได้รับรางวัล ${this.prizes[this.prize - 1].value} บาท`, error: false });
    this.$store.dispatch('Profile/fetchBalance');
    this.$store.dispatch('Profile/getProfile');
    this.disabled = false;
  }

  // eslint-disable-next-line class-methods-use-this
  get prizes() {
    return [
      {
        id: 1,
        name: '1000',
        value: 1000,
        bgColor: '#45ace9',
        color: '#ffffff',
        probability: 1,
      },
      {
        id: 2,
        name: '5',
        value: 5,
        bgColor: '#dd3832',
        color: '#ffffff',
        probability: 45,
      },
      {
        id: 3,
        name: '50',
        value: 50,
        bgColor: '#fef151',
        color: '#ffffff',
        probability: 13,
      },
      {
        id: 4,
        name: '500',
        value: 500,
        bgColor: '#45ace9',
        color: '#ffffff',
        probability: 1,
      },
      {
        id: 5,
        name: '10',
        value: 10,
        bgColor: '#fef151',
        color: '#ffffff',
        probability: 35,
      },
      {
        id: 6,
        name: '100',
        value: 100,
        bgColor: '#dd3832',
        color: '#ffffff',
        probability: 5,
      },
    ];
  }

  async fetchFortuneWheelData() {
    try {
      const { data } = await fortuneWheelService.fetchData();
      this.fortuneWheelData = { ...data };
      this.retry = false;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.retry = true;
    }
  }

  async created() {
    await this.fetchFortuneWheelData();
  }

  async destroyed() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.fortuneWheelData._id) {
      // eslint-disable-next-line no-underscore-dangle
      await fortuneWheelService.invalidFortunWheel(this.fortuneWheelData._id, { eligible: 2 });
    }
  }
}
</script>

<style>
.fw-btn__image {
  cursor: pointer;
  width: 25%;
  margin-top: -2.15rem;
  margin-left: -.1rem;
}
</style>
